import React from 'react';
import EditMasterNoteModal from '../../modals/EditMasterNoteModal';
import EditStdLoanModal from '../../modals/EditStdLoanModal';
import DeleteLoanModal from '../../modals/DeleteLoanModal';
import LoseLoanModal from '../../modals/LoseLoanModal';
import ExtensionModal from '../../modals/ExtensionModal';
import RepaymentModal from '../../modals/RepaymentModal';
import ReleaseHoldbackModal from '../../modals/ReleaseHoldbackModal';
import RentalDscrModal from '../../modals/RentalDscrModal';
import BuildRentConversionModal from '../../modals/BuildRentConversionModal';
import RevertToApproved from '../../modals/RevertToApproved';
import RestoreLoanModal from '../../modals/RestoreLoanModal';
import ChangeLoanTypeModal from '../../modals/ChangeLoanTypeModal';
import PropertyInsuranceModal from '../../insurance/modals/PropertyInsuranceModal';
import LoanSummaryModal from '../../modals/LoanSummaryModal';
import TerminateMasterNoteModal from '../../modals/TerminateMasterNoteModal';
import AuditHistoryModal from '../../modals/AuditHistoryModal';
import WatchlistLoanDetailsModal from '../../../watchlists/modals/WatchlistLoanDetailsModal';
import LoanSetupSheetModal from '../../modals/LoanSetupSheetModal';

export const LoanModals = () => {
    return (
        <>
            <EditMasterNoteModal />
            <EditStdLoanModal />
            <DeleteLoanModal />
            <LoseLoanModal />
            <ExtensionModal />
            <RepaymentModal />
            <ReleaseHoldbackModal />
            <RentalDscrModal />
            <BuildRentConversionModal />
            <RevertToApproved />
            <RestoreLoanModal />
            <ChangeLoanTypeModal />
            <PropertyInsuranceModal />
            <LoanSummaryModal />
            <TerminateMasterNoteModal />
            <AuditHistoryModal />
            <WatchlistLoanDetailsModal />
            <LoanSetupSheetModal />
        </>
    );
};
